export const textIcon = (text) => `
  <span style="
    background-color: rgba(47, 199, 114, 0.7);
    color:white;
    display:inline-block;
    vertical-align:middle;
    padding: 5px;
    border-radius:50%;
    line-height: 1;
    width: 28px;
    height:28px;
    text-align: center;
    font-size: 7px;
    padding-top: 11px;
    text-transform: uppercase;
  ">
    ${text}
  </span>
`;

const getIconByType = (type) => {
  switch (type) {
    case 'new':
      return 'NEW';
    default:
      return `icon-${type}`;
  }
};
const Icon = ({
  type,
  size = 18,
  color,
  rounded,
  marginBottom,
  marginRight,
}) => {
  const icon = getIconByType(type);
  return `
    <span
      class="${icon}"
      style="
        display:inline-block;
        vertical-align: middle;
        color: ${rounded ? 'white' : color};
        background-color: ${rounded ? color : ''};
        font-size: ${size}px;
        ${rounded ? 'padding: 5px;' : ''}
        ${rounded ? 'border-radius: 50%;' : ''}
        ${marginBottom ? `margin-bottom: ${marginBottom};` : ''}
        ${marginRight ? `margin-right: ${marginRight};` : ''}
      "
    >
    </span>
  `;
};

export const globeIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" data-code="59850" data-tags="earth,globe,language,web,internet,sphere,planet"><path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm0 30c-1.967 0-3.84-.407-5.538-1.14l7.285-8.196A1 1 0 0 0 18 20v-3a1 1 0 0 0-1-1c-3.53 0-7.256-3.67-7.293-3.707A1 1 0 0 0 9 12H5a1 1 0 0 0-1 1v6a1 1 0 0 0 .553.894L8 21.618v5.871C4.373 24.96 2 20.757 2 16c0-2.147.484-4.181 1.348-6H7a1 1 0 0 0 .707-.293l4-4A1 1 0 0 0 12 5V2.58A14 14 0 0 1 16 2c2.2 0 4.281.508 6.134 1.412A5.96 5.96 0 0 0 20 8a5.96 5.96 0 0 0 1.757 4.243 5.986 5.986 0 0 0 4.536 1.75c.432 1.62 1.211 5.833-.262 11.636a.997.997 0 0 0-.027.163A13.956 13.956 0 0 1 16 30z" fill="#444"/></svg>';

export const chevronIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="451.847" height="451.847" viewBox="0 0 451.847 451.847"><path d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"/></svg>';
export const volumeIcon =
  '<svg height="12" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="M1.228 2.517h1.909L6.119.086A.329.329 0 0 1 6.34 0c.18 0 .326.142.326.317v9.366h-.001a.31.31 0 0 1-.076.203.33.33 0 0 1-.457.04L3.137 7.484H1.228c-.338 0-.645-.135-.868-.352A1.18 1.18 0 0 1 0 6.286v-2.57c0-.33.138-.63.36-.847.223-.217.53-.352.868-.352ZM8.413 3.295a.23.23 0 0 1 0-.348.295.295 0 0 1 .387 0c.696.628 1.044 1.45 1.044 2.273 0 .822-.348 1.645-1.044 2.273a.295.295 0 0 1-.387 0 .23.23 0 0 1 0-.349c.59-.53.884-1.227.884-1.924 0-.697-.294-1.393-.884-1.924Z"/><path d="M9.782 2.087a.23.23 0 0 1 0-.348.295.295 0 0 1 .386 0c1 .9 1.499 2.08 1.499 3.261 0 1.18-.5 2.36-1.499 3.261a.295.295 0 0 1-.386 0 .23.23 0 0 1 0-.348C10.674 7.11 11.12 6.055 11.12 5c0-1.054-.446-2.109-1.338-2.913Z"/></g></svg>';
export const muteIcon =
  '<svg height="12" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="m10.411 5 1.17-1.17a.29.29 0 1 0-.411-.411L10 4.589l-1.17-1.17a.29.29 0 1 0-.411.411L9.589 5l-1.17 1.17a.29.29 0 1 0 .411.412L10 5.412l1.17 1.17a.29.29 0 0 0 .411 0 .29.29 0 0 0 0-.412L10.411 5Z" fill-rule="nonzero"/><path d="M1.228 2.517h1.909L6.119.086A.329.329 0 0 1 6.34 0c.18 0 .326.142.326.317v9.366h-.001a.31.31 0 0 1-.076.203.33.33 0 0 1-.457.04L3.137 7.484H1.228c-.338 0-.645-.135-.868-.352A1.18 1.18 0 0 1 0 6.286v-2.57c0-.33.138-.63.36-.847.223-.217.53-.352.868-.352Z"/></g></svg>';

export default Icon;
